"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/spwn/v1/portal_common.proto (package spwn.spwn.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecureTran2Response = exports.SecureTran2Error = exports.SecureTran2Success = exports.PawUsageHistory = exports.PawChargeHistory = exports.FetchPawBalance = exports.PawPaymentStatus = exports.PawPaymentMethod = exports.SpwnApiResponse = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.spwn.v1.SpwnApiResponse
 */
var SpwnApiResponse;
(function (SpwnApiResponse) {
    /**
     * @generated from enum value: SPWN_API_RESPONSE_UNSPECIFIED = 0;
     */
    SpwnApiResponse[SpwnApiResponse["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: SPWN_API_RESPONSE_SUCCESS = 1;
     */
    SpwnApiResponse[SpwnApiResponse["SUCCESS"] = 1] = "SUCCESS";
    /**
     * @generated from enum value: SPWN_API_RESPONSE_ERROR = 2;
     */
    SpwnApiResponse[SpwnApiResponse["ERROR"] = 2] = "ERROR";
})(SpwnApiResponse || (exports.SpwnApiResponse = SpwnApiResponse = {}));
// Retrieve enum metadata with: proto3.getEnumType(SpwnApiResponse)
protobuf_1.proto3.util.setEnumType(SpwnApiResponse, "spwn.spwn.v1.SpwnApiResponse", [
    { no: 0, name: "SPWN_API_RESPONSE_UNSPECIFIED" },
    { no: 1, name: "SPWN_API_RESPONSE_SUCCESS" },
    { no: 2, name: "SPWN_API_RESPONSE_ERROR" },
]);
/**
 * @generated from enum spwn.spwn.v1.PawPaymentMethod
 */
var PawPaymentMethod;
(function (PawPaymentMethod) {
    /**
     * @generated from enum value: PAW_PAYMENT_METHOD_UNSPECIFIED = 0;
     */
    PawPaymentMethod[PawPaymentMethod["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PAW_PAYMENT_METHOD_CARD = 1;
     */
    PawPaymentMethod[PawPaymentMethod["CARD"] = 1] = "CARD";
    /**
     * @generated from enum value: PAW_PAYMENT_METHOD_TOKEN = 2;
     */
    PawPaymentMethod[PawPaymentMethod["TOKEN"] = 2] = "TOKEN";
    /**
     * @generated from enum value: PAW_PAYMENT_METHOD_MEMBER = 3;
     */
    PawPaymentMethod[PawPaymentMethod["MEMBER"] = 3] = "MEMBER";
    /**
     * @generated from enum value: PAW_PAYMENT_METHOD_CVS = 4;
     */
    PawPaymentMethod[PawPaymentMethod["CVS"] = 4] = "CVS";
    /**
     * @generated from enum value: PAW_PAYMENT_METHOD_PAYEASY = 5;
     */
    PawPaymentMethod[PawPaymentMethod["PAYEASY"] = 5] = "PAYEASY";
    /**
     * @generated from enum value: PAW_PAYMENT_METHOD_SHOP = 6;
     */
    PawPaymentMethod[PawPaymentMethod["SHOP"] = 6] = "SHOP";
})(PawPaymentMethod || (exports.PawPaymentMethod = PawPaymentMethod = {}));
// Retrieve enum metadata with: proto3.getEnumType(PawPaymentMethod)
protobuf_1.proto3.util.setEnumType(PawPaymentMethod, "spwn.spwn.v1.PawPaymentMethod", [
    { no: 0, name: "PAW_PAYMENT_METHOD_UNSPECIFIED" },
    { no: 1, name: "PAW_PAYMENT_METHOD_CARD" },
    { no: 2, name: "PAW_PAYMENT_METHOD_TOKEN" },
    { no: 3, name: "PAW_PAYMENT_METHOD_MEMBER" },
    { no: 4, name: "PAW_PAYMENT_METHOD_CVS" },
    { no: 5, name: "PAW_PAYMENT_METHOD_PAYEASY" },
    { no: 6, name: "PAW_PAYMENT_METHOD_SHOP" },
]);
/**
 * @generated from enum spwn.spwn.v1.PawPaymentStatus
 */
var PawPaymentStatus;
(function (PawPaymentStatus) {
    /**
     * @generated from enum value: PAW_PAYMENT_STATUS_UNSPECIFIED = 0;
     */
    PawPaymentStatus[PawPaymentStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PAW_PAYMENT_STATUS_UNPROCESSED = 1;
     */
    PawPaymentStatus[PawPaymentStatus["UNPROCESSED"] = 1] = "UNPROCESSED";
    /**
     * @generated from enum value: PAW_PAYMENT_STATUS_AUTHENTICATED = 2;
     */
    PawPaymentStatus[PawPaymentStatus["AUTHENTICATED"] = 2] = "AUTHENTICATED";
    /**
     * @generated from enum value: PAW_PAYMENT_STATUS_AUTHPROCESSING = 3;
     */
    PawPaymentStatus[PawPaymentStatus["AUTHPROCESSING"] = 3] = "AUTHPROCESSING";
    /**
     * @generated from enum value: PAW_PAYMENT_STATUS_PAYWAITING = 4;
     */
    PawPaymentStatus[PawPaymentStatus["PAYWAITING"] = 4] = "PAYWAITING";
    /**
     * @generated from enum value: PAW_PAYMENT_STATUS_CHARGE = 5;
     */
    PawPaymentStatus[PawPaymentStatus["CHARGE"] = 5] = "CHARGE";
    /**
     * @generated from enum value: PAW_PAYMENT_STATUS_PAYEXPIRED = 6;
     */
    PawPaymentStatus[PawPaymentStatus["PAYEXPIRED"] = 6] = "PAYEXPIRED";
    /**
     * @generated from enum value: PAW_PAYMENT_STATUS_PAYFAIL = 7;
     */
    PawPaymentStatus[PawPaymentStatus["PAYFAIL"] = 7] = "PAYFAIL";
    /**
     * @generated from enum value: PAW_PAYMENT_STATUS_PAYCANCEL = 8;
     */
    PawPaymentStatus[PawPaymentStatus["PAYCANCEL"] = 8] = "PAYCANCEL";
})(PawPaymentStatus || (exports.PawPaymentStatus = PawPaymentStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(PawPaymentStatus)
protobuf_1.proto3.util.setEnumType(PawPaymentStatus, "spwn.spwn.v1.PawPaymentStatus", [
    { no: 0, name: "PAW_PAYMENT_STATUS_UNSPECIFIED" },
    { no: 1, name: "PAW_PAYMENT_STATUS_UNPROCESSED" },
    { no: 2, name: "PAW_PAYMENT_STATUS_AUTHENTICATED" },
    { no: 3, name: "PAW_PAYMENT_STATUS_AUTHPROCESSING" },
    { no: 4, name: "PAW_PAYMENT_STATUS_PAYWAITING" },
    { no: 5, name: "PAW_PAYMENT_STATUS_CHARGE" },
    { no: 6, name: "PAW_PAYMENT_STATUS_PAYEXPIRED" },
    { no: 7, name: "PAW_PAYMENT_STATUS_PAYFAIL" },
    { no: 8, name: "PAW_PAYMENT_STATUS_PAYCANCEL" },
]);
/**
 * @generated from message spwn.spwn.v1.FetchPawBalance
 */
class FetchPawBalance extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int64 balance = 1;
         */
        this.balance = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new FetchPawBalance().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FetchPawBalance().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FetchPawBalance().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(FetchPawBalance, a, b);
    }
}
exports.FetchPawBalance = FetchPawBalance;
FetchPawBalance.runtime = protobuf_1.proto3;
FetchPawBalance.typeName = "spwn.spwn.v1.FetchPawBalance";
FetchPawBalance.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "balance", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.spwn.v1.PawChargeHistory
 */
class PawChargeHistory extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string charge_history_id = 1;
         */
        this.chargeHistoryId = "";
        /**
         * @generated from field: int64 value = 2;
         */
        this.value = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 valid_value = 3;
         */
        this.validValue = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 expires_at = 4;
         */
        this.expiresAt = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 charged_at = 5;
         */
        this.chargedAt = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: spwn.spwn.v1.PawPaymentMethod payment_method = 6;
         */
        this.paymentMethod = PawPaymentMethod.UNSPECIFIED;
        /**
         * @generated from field: spwn.spwn.v1.PawPaymentStatus payment_status = 7;
         */
        this.paymentStatus = PawPaymentStatus.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PawChargeHistory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PawChargeHistory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PawChargeHistory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PawChargeHistory, a, b);
    }
}
exports.PawChargeHistory = PawChargeHistory;
PawChargeHistory.runtime = protobuf_1.proto3;
PawChargeHistory.typeName = "spwn.spwn.v1.PawChargeHistory";
PawChargeHistory.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "charge_history_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "valid_value", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "expires_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "charged_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "payment_method", kind: "enum", T: protobuf_1.proto3.getEnumType(PawPaymentMethod) },
    { no: 7, name: "payment_status", kind: "enum", T: protobuf_1.proto3.getEnumType(PawPaymentStatus) },
]);
/**
 * @generated from message spwn.spwn.v1.PawUsageHistory
 */
class PawUsageHistory extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string paw_usage_history_id = 1;
         */
        this.pawUsageHistoryId = "";
        /**
         * @generated from field: string item_id = 2;
         */
        this.itemId = "";
        /**
         * @generated from field: string item_name = 3;
         */
        this.itemName = "";
        /**
         * @generated from field: string event_id = 4;
         */
        this.eventId = "";
        /**
         * @generated from field: int64 price = 5;
         */
        this.price = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 used_at = 6;
         */
        this.usedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PawUsageHistory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PawUsageHistory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PawUsageHistory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PawUsageHistory, a, b);
    }
}
exports.PawUsageHistory = PawUsageHistory;
PawUsageHistory.runtime = protobuf_1.proto3;
PawUsageHistory.typeName = "spwn.spwn.v1.PawUsageHistory";
PawUsageHistory.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "paw_usage_history_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "item_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "used_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.spwn.v1.SecureTran2Success
 */
class SecureTran2Success extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * オーダーID (EntryTranで指定したID)
         *
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        /**
         * 承認番号
         *
         * @generated from field: string approve = 2;
         */
        this.approve = "";
        /**
         * トランザクションID
         *
         * @generated from field: string tran_id = 3;
         */
        this.tranId = "";
        /**
         * 決済日付 (YYYYMMDDHHMMSS)
         *
         * @generated from field: string tran_date = 4;
         */
        this.tranDate = "";
        /**
         * MD5ハッシュ (出力パラメータのハッシュ値)
         *
         * @generated from field: string check_string = 5;
         */
        this.checkString = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SecureTran2Success().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SecureTran2Success().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SecureTran2Success().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SecureTran2Success, a, b);
    }
}
exports.SecureTran2Success = SecureTran2Success;
SecureTran2Success.runtime = protobuf_1.proto3;
SecureTran2Success.typeName = "spwn.spwn.v1.SecureTran2Success";
SecureTran2Success.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "approve", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "tran_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "tran_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "check_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "forward", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "method", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "pay_times", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "client_field1", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "client_field2", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "client_field3", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message spwn.spwn.v1.SecureTran2Error
 */
class SecureTran2Error extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * エラーコード (例: "E01")
         *
         * @generated from field: string err_code = 1;
         */
        this.errCode = "";
        /**
         * エラー情報コード (例: "E01040001")
         *
         * @generated from field: string err_info = 2;
         */
        this.errInfo = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SecureTran2Error().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SecureTran2Error().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SecureTran2Error().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SecureTran2Error, a, b);
    }
}
exports.SecureTran2Error = SecureTran2Error;
SecureTran2Error.runtime = protobuf_1.proto3;
SecureTran2Error.typeName = "spwn.spwn.v1.SecureTran2Error";
SecureTran2Error.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "err_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "err_info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "tran_date", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "client_field1", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "client_field2", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "client_field3", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message spwn.spwn.v1.SecureTran2Response
 */
class SecureTran2Response extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.spwn.v1.SecureTran2Response.result
         */
        this.result = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SecureTran2Response().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SecureTran2Response().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SecureTran2Response().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SecureTran2Response, a, b);
    }
}
exports.SecureTran2Response = SecureTran2Response;
SecureTran2Response.runtime = protobuf_1.proto3;
SecureTran2Response.typeName = "spwn.spwn.v1.SecureTran2Response";
SecureTran2Response.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "success_response", kind: "message", T: SecureTran2Success, oneof: "result" },
    { no: 2, name: "error_response", kind: "message", T: SecureTran2Error, oneof: "result" },
]);
//# sourceMappingURL=portal_common_pb.js.map